import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'react-icons-kit';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import 'rc-tabs/assets/index.css';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Image from 'reusecore/src/elements/Image';
import Container from 'common/src/components/UI/Container';
import { ic_arrow_back } from 'react-icons-kit/md/ic_arrow_back'
import { ic_arrow_forward } from 'react-icons-kit/md/ic_arrow_forward'

import SectionWrapper from './updateScreen.style';
import { SCREENSHOTS } from 'common/src/data/SaasClassic';

import Fade from 'react-reveal/Fade';
import Pulse from 'react-reveal/Pulse';
import Slide from 'react-reveal/Slide';
import Flip from 'react-reveal/Flip';
import Zoom from 'react-reveal/Zoom';
import HeadShake from 'react-reveal/HeadShake';
import Jello from 'react-reveal/Jello';


const UpdateScreen = ({ secTitleWrapper, secText, secHeading }) => {
  return (
    <SectionWrapper id="solutions_section">
      <Container>
        <Fade up>
          <Box {...secTitleWrapper}>
            <Text {...secText} content="" />
            <Heading
              {...secHeading}
              content="Custom chat experience for each genre"
            />
          </Box>
        </Fade>
        <Tabs
          renderTabBar={() => <ScrollableInkTabBar
            nextIcon={<Icon icon={ic_arrow_forward} size={15} />}
            prevIcon={<Icon icon={ic_arrow_back} size={15} />}
          />}
          renderTabContent={() => <TabContent animated={false} />}
          className="update-screen-tab"
        >
          {SCREENSHOTS.map((item, index) => (
            <TabPane
              tab={
                <>
                  {/* <Icon icon={item.icon} size={24} /> */}
                  <Fade right>
                    {item.title}
                  </Fade>
                </>
              }
              key={index + 1}
            >
              {/* <HeadShake> */}
              <Image src={item.image} alt={`screenshot-${index + 1}`} />
              {/* </HeadShake> */}
            </TabPane>
          ))}
        </Tabs>
      </Container>
    </SectionWrapper>
  );
};

UpdateScreen.propTypes = {
  secTitleWrapper: PropTypes.object,
  secText: PropTypes.object,
  secHeading: PropTypes.object,
};

UpdateScreen.defaultProps = {
  secTitleWrapper: {
    mb: ['60px', '80px'],
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#ff4362',
    mb: '12px',
  },
  secHeading: {
    textAlign: 'center',
    fontSize: ['20px', '24px', '36px', '36px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '0',
    ml: 'auto',
    mr: 'auto',
    lineHeight: '1.12',
    width: '540px',
    maxWidth: '100%',
  },
};

export default UpdateScreen;
